import {
  canReadText as canReadTextUtility,
  getRGB,
} from 'foundations-components/transitional/utils/color';
import { Theme } from 'foundations-theming';

const CONTRAST_THRESHOLD_OVERRIDE = 2.0;
const WHITENESS_THRESHOLD = 0.95;

export function canReadText(
  backgroundHex: string,
  theme: Theme,
  textColor?: string
) {
  return canReadTextUtility(
    backgroundHex,
    textColor || theme.color['text-primary-default'],
    CONTRAST_THRESHOLD_OVERRIDE
  );
}

export function getTextColorWithTheme(primaryColor: string, theme: Theme) {
  const whiteColor = theme.color['text-primary-default'];
  const darkColor = theme.color['text-core-default'];
  return canReadText(primaryColor, theme, whiteColor) ? whiteColor : darkColor;
}

export function getWhiteness(hex: string): boolean {
  const { r: rRaw, g: gRaw, b: bRaw } = getRGB(hex);
  const r = rRaw / 255.0;
  const g = gRaw / 255.0;
  const b = bRaw / 255.0;
  const cmin = Math.min(r, g, b);
  const cmax = Math.max(r, g, b);
  const whiteness = (cmin + cmax) / 2;
  return whiteness >= WHITENESS_THRESHOLD;
}
